export type PersistedStoreState = {
  hydrated?: boolean;
};

export type StoreHydrationAction = {
  hydrate: () => Promise<void>;
  persist: () => Promise<void>;
};

export type StoreAction<State = unknown, Action = object> = Omit<
  Action,
  keyof StoreHydrationAction
> & {
  reset?: (initial?: Partial<State>) => void;
};

export type StoreConfig<State = unknown, Action = object> = {
  actions: StoreAction<State, Action>;
  initial: Readonly<State>;
  state: Readonly<State>;
};

export const basePersistenceStoreKey = 'ngsq-ai-scoring-input-web';
